/**
 * Proje `domain`'inden MUTLAK origin üretimi.
 *
 * İKİ ÇAĞIRAN, TEK KURAL:
 *  - §23.5 ısı haritası — canlı sayfayı iframe'e yükler (`buildFrameSrc`).
 *  - §22.4 replay oynatıcı — snapshot'a `<base href>` enjekte eder.
 *
 * Ayrışmaları hâlinde aynı proje ısı haritasında `https://`, replay'de `http://`
 * çözülür ve ikisinden biri sessizce kırılırdı; kural burada tek yerde durur.
 */

/**
 * `projects.domain` → `https://ornek.com/` biçiminde origin (sonda `/` VARDIR:
 * `<base href>` ve `new URL(path, base)` ikisi de dizin köküne çözmelidir).
 * Boş/bozuk domain'de `null` — çağıran fallback'ine düşer, panel çökmez.
 */
export function projectOrigin(domain: string | null | undefined): string | null {
  if (domain === null || domain === undefined || domain === '') return null;
  /*
   * Şemasız domain'de varsayılan https'tir — gerçek müşteri siteleri için doğru olan bu.
   * TEK İSTİSNA loopback: demo/geliştirme projesinin domain'i `localhost:4300` gibi
   * açık portlu bir loopback adresidir ve http servis eder; https varsaymak adresi
   * HİÇ yükletmezdi.
   */
  const loopback = /^(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(domain);
  const base = /^https?:\/\//i.test(domain)
    ? domain
    : `${loopback ? 'http' : 'https'}://${domain}`;
  try {
    return new URL(`${base.replace(/\/+$/, '')}/`).toString();
  } catch {
    return null;
  }
}
